import { fromJS } from 'immutable';

import * as actions from '../../actions/maintenance/websiteAdmin';
import { START, SUCCESS, ERROR } from '../../actions/maintenance/global';
import { fetchingState } from '../../constants';

const initialState = {
  reports: { data: [], state: null },
  reportCategories: [],
  reportTypes: [],
  taxingUnits: [],
  forms: { data: [], state: null },
  formTypes: [],
  news: { data: [], state: null },
  announcements: { data: [], state: null },
  members: { data: [], state: null },
  meetings: { data: [], state: null },
  links: { data: [], state: null },
  languages: [],
  settings: {},
  onlineFormTypes: { data: [], state: null },
  quickLinks: { data: [], state: null },
  tiles: { data: [], state: null },
  appraisalNoticeForms: { data: [], state: null },
  appraisalNoticeFormOptions: { data: [], state: null },
};

const formatDate = (dateT) => {
  return `${dateT.getFullYear()}-${
    String(dateT.getMonth() + 1).length === 1
      ? `0${dateT.getMonth() + 1}`
      : dateT.getMonth() + 1
  }-${
    String(dateT.getDate()).length === 1
      ? `0${dateT.getDate()}`
      : dateT.getDate()
  }`;
};

const formatTime = (dateT) => {
  return `${
    String(dateT.getHours()).length === 1
      ? `0${dateT.getHours()}`
      : dateT.getHours()
  }:${
    String(dateT.getMinutes()).length === 1
      ? `0${dateT.getMinutes()}`
      : dateT.getMinutes()
  }`;
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_REPORTS[START]:
      return state.setIn(['reports', 'state'], fetchingState.FETCHING);
    case actions.FETCH_REPORTS[SUCCESS]:
      return state
        .setIn(['reports', 'state'], fetchingState.LOADED)
        .setIn(['reports', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_REPORTS[ERROR]:
      return state.setIn(['reports', 'state'], fetchingState.ERROR);

    case actions.DELETE_REPORT[SUCCESS]: {
      let list = state.getIn(['reports', 'data']).toJS();
      list = list.filter((l) => l.reportID !== action.reportID);
      return state.setIn(['reports', 'data'], fromJS(list));
    }

    case actions.FETCH_REPORT_CATEGORIES[SUCCESS]:
      return state.setIn(
        ['reportCategories'],
        fromJS(action.data.results || []),
      );

    case actions.INSERT_REPORT[SUCCESS]: {
      let list = state.getIn(['reports', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['reports', 'data'], fromJS(list));
    }

    case actions.UPDATE_REPORT[SUCCESS]: {
      let list = state.getIn(['reports', 'data']).toJS();
      list = list.map((l) =>
        l.reportID === action.reportID ? action.data.results[0] : l,
      );
      return state.setIn(['reports', 'data'], fromJS(list));
    }

    case actions.FETCH_REPORT_TYPES[SUCCESS]:
      return state.setIn(['reportTypes'], fromJS(action.data.results || []));

    case actions.UNFLAG_NEW_REPORT: {
      let list = state.getIn(['reports', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['reports', 'data'], fromJS(list));
    }

    case actions.FETCH_TAXING_UNITS[SUCCESS]:
      return state.setIn(['taxingUnits'], fromJS(action.data.results || []));

    case actions.FETCH_FORMS[START]:
      return state.setIn(['forms', 'state'], fetchingState.FETCHING);
    case actions.FETCH_FORMS[SUCCESS]:
      return state
        .setIn(['forms', 'state'], fetchingState.LOADED)
        .setIn(['forms', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_FORMS[ERROR]:
      return state.setIn(['forms', 'state'], fetchingState.ERROR);

    case actions.DELETE_FORM[SUCCESS]: {
      let list = state.getIn(['forms', 'data']).toJS();
      list = list.filter((l) => l.formID !== action.formID);
      return state.setIn(['forms', 'data'], fromJS(list));
    }

    case actions.INSERT_FORM[SUCCESS]: {
      let list = state.getIn(['forms', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['forms', 'data'], fromJS(list));
    }

    case actions.UPDATE_FORM[SUCCESS]: {
      let list = state.getIn(['forms', 'data']).toJS();
      list = list.map((l) =>
        l.formID === action.formID ? action.data.results[0] : l,
      );
      return state.setIn(['forms', 'data'], fromJS(list));
    }

    case actions.UNFLAG_NEW_FORM: {
      let list = state.getIn(['forms', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['forms', 'data'], fromJS(list));
    }

    case actions.FETCH_FORM_TYPES[SUCCESS]:
      return state.setIn(['formTypes'], fromJS(action.data.results || []));

    case actions.FETCH_ALL_NEWS[START]:
      return state.setIn(['news', 'state'], fetchingState.FETCHING);
    case actions.FETCH_ALL_NEWS[SUCCESS]:
      return state
        .setIn(['news', 'state'], fetchingState.LOADED)
        .setIn(['news', 'data'], fromJS(action.data.results || []));
    case actions.FETCH_ALL_NEWS[ERROR]:
      return state.setIn(['news', 'state'], fetchingState.ERROR);

    case actions.FETCH_LINKS[START]:
      return state.setIn(['links', 'state'], fetchingState.FETCHING);
    case actions.FETCH_LINKS[SUCCESS]: {
      let result = [];
      if (action?.data?.results) {
        result = action.data.results;
      }
      return state
        .setIn(['links', 'state'], fetchingState.LOADED)
        .setIn(['links', 'data'], fromJS(result));
    }
    case actions.FETCH_LINKS[ERROR]:
      return state.setIn(['links', 'state'], fetchingState.ERROR);

    case actions.FETCH_MEMBERS[START]:
      return state.setIn(['members', 'state'], fetchingState.FETCHING);
    case actions.FETCH_MEMBERS[SUCCESS]: {
      const result = [];
      if (action?.data?.results) {
        for (let x = 0; x < action.data.results.length; x++) {
          for (let y = 0; y < action.data.results[x].members.length; y++) {
            result.push(action.data.results[x].members[y]);
          }
        }
      }
      return state
        .setIn(['members', 'state'], fetchingState.LOADED)
        .setIn(['members', 'data'], fromJS(result));
    }
    case actions.FETCH_MEMBERS[ERROR]:
      return state.setIn(['members', 'state'], fetchingState.ERROR);

    case actions.FETCH_MEETINGS[START]:
      return state.setIn(['meetings', 'state'], fetchingState.FETCHING);
    case actions.FETCH_MEETINGS[SUCCESS]: {
      const result = [];
      let temp = null;
      let dateData = null;
      if (action?.data?.results) {
        for (let x = 0; x < action.data.results.length; x++) {
          temp = action.data.results[x];
          if (temp.meetingDt) {
            dateData = new Date(Date.parse(temp.meetingDt));
            temp.date = formatDate(dateData);
            temp.time = formatTime(dateData);
          }
          result.push(temp);
        }
      }
      return state
        .setIn(['meetings', 'state'], fetchingState.LOADED)
        .setIn(['meetings', 'data'], fromJS(result || []));
    }
    case actions.FETCH_MEETINGS[ERROR]:
      return state.setIn(['meetings', 'state'], fetchingState.ERROR);

    case actions.DELETE_NEWS[SUCCESS]: {
      let list = state.getIn(['news', 'data']).toJS();
      list = list.filter((l) => l.newsID !== action.newsID);
      return state.setIn(['news', 'data'], fromJS(list));
    }

    case actions.INSERT_NEWS[SUCCESS]: {
      let list = state.getIn(['news', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['news', 'data'], fromJS(list));
    }

    case actions.UPDATE_NEWS[SUCCESS]: {
      let list = state.getIn(['news', 'data']).toJS();
      list = list.map((l) =>
        l.newsID === action.newsID ? action.data.results[0] : l,
      );
      return state.setIn(['news', 'data'], fromJS(list));
    }

    case actions.UNFLAG_NEW_NEWS: {
      let list = state.getIn(['news', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['news', 'data'], fromJS(list));
    }

    case actions.FETCH_ANNOUNCEMENTS[START]:
      return state.setIn(['announcements', 'state'], fetchingState.FETCHING);
    case actions.FETCH_ANNOUNCEMENTS[SUCCESS]:
      return state
        .setIn(['announcements', 'state'], fetchingState.LOADED)
        .setIn(
          ['announcements', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case actions.FETCH_ANNOUNCEMENTS[ERROR]:
      return state.setIn(['announcements', 'state'], fetchingState.ERROR);

    case actions.DELETE_ANNOUNCEMENT[SUCCESS]: {
      let list = state.getIn(['announcements', 'data']).toJS();
      list = list.filter((l) => l.psaID !== action.psaID);
      return state.setIn(['announcements', 'data'], fromJS(list));
    }

    case actions.INSERT_ANNOUNCEMENT[SUCCESS]: {
      let list = state.getIn(['announcements', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['announcements', 'data'], fromJS(list));
    }

    case actions.UPDATE_ANNOUNCEMENT[SUCCESS]: {
      let list = state.getIn(['announcements', 'data']).toJS();
      list = list.map((l) =>
        l.psaID === action.psaID ? action.data.results[0] : l,
      );
      return state.setIn(['announcements', 'data'], fromJS(list));
    }

    case actions.UNFLAG_NEW_ANNOUNCEMENT: {
      let list = state.getIn(['announcements', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['announcements', 'data'], fromJS(list));
    }

    case actions.FETCH_LANGUAGES[SUCCESS]:
      return state.setIn(['languages'], fromJS(action.data.results || []));

    case actions.UPDATE_SETTINGS[SUCCESS]:
      return state.setIn(
        ['settings'],
        fromJS(action.data.results ? action.data.results[0] : {}),
      );

    case actions.FETCH_SETTINGS[SUCCESS]:
      return state.setIn(['settings'], fromJS(action.data.results || {}));

    case actions.FETCH_ONLINE_FORM_TYPES[START]:
      return state.setIn(['onlineFormTypes', 'state'], fetchingState.FETCHING);
    case actions.FETCH_ONLINE_FORM_TYPES[SUCCESS]:
      return state
        .setIn(['onlineFormTypes', 'state'], fetchingState.LOADED)
        .setIn(['onlineFormTypes', 'data'], fromJS(action.data || []));
    case actions.FETCH_ONLINE_FORM_TYPES[ERROR]:
      return state.setIn(['onlineFormTypes', 'state'], fetchingState.ERROR);

    case actions.FETCH_ALL_QUICK_LINKS[START]:
      return state.setIn(['quickLinks', 'state'], fetchingState.FETCHING);
    case actions.FETCH_ALL_QUICK_LINKS[SUCCESS]:
      return state
        .setIn(['quickLinks', 'state'], fetchingState.LOADED)
        .setIn(['quickLinks', 'data'], fromJS(action.data?.results || []));
    case actions.FETCH_ALL_QUICK_LINKS[ERROR]:
      return state.setIn(['quickLinks', 'state'], fetchingState.ERROR);

    case actions.INSERT_QUICK_LINK[SUCCESS]: {
      let list = state.getIn(['quickLinks', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['quickLinks', 'data'], fromJS(list));
    }

    case actions.UPDATE_QUICK_LINK[SUCCESS]: {
      let list = state.getIn(['quickLinks', 'data']).toJS();
      list = list.map((l) =>
        l.quickLinkID === action.quickLinkID ? action.data.results[0] : l,
      );
      return state.setIn(['quickLinks', 'data'], fromJS(list));
    }

    case actions.FETCH_ALL_TILES[START]:
      return state.setIn(['tiles', 'state'], fetchingState.FETCHING);
    case actions.FETCH_ALL_TILES[SUCCESS]:
      return state
        .setIn(['tiles', 'state'], fetchingState.LOADED)
        .setIn(['tiles', 'data'], fromJS(action?.data?.results || []));
    case actions.FETCH_ALL_TILES[ERROR]:
      return state.setIn(['tiles', 'state'], fetchingState.ERROR);

    case actions.INSERT_TILE[SUCCESS]: {
      let list = state.getIn(['tiles', 'data']).toJS();
      list = [{ ...action.data.results[0], isNew: true }].concat(list);
      return state.setIn(['tiles', 'data'], fromJS(list));
    }

    case actions.UPDATE_TILE[SUCCESS]: {
      let list = state.getIn(['tiles', 'data']).toJS();
      list = list.map((l) =>
        l.tileID === action.tileID ? action.data.results[0] : l,
      );
      return state.setIn(['tiles', 'data'], fromJS(list));
    }

    case actions.UNFLAG_NEW_QUICK_LINK: {
      let list = state.getIn(['quickLinks', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['quickLinks', 'data'], fromJS(list));
    }

    case actions.UNFLAG_NEW_TILE: {
      let list = state.getIn(['tiles', 'data']).toJS();
      list = list.map((l) => ({ ...l, isNew: false }));
      return state.setIn(['tiles', 'data'], fromJS(list));
    }

    case actions.DELETE_APPRAISAL_NOTICE_FORM: {
      let list = state.getIn(['appraisalNoticeForms', 'data']).toJS();
      const filtered = list.filter(
        (form) =>
          form.publicApprNoticeFormConfigID !==
          action.data.publicApprNoticeFormConfigID,
      );
      return state.setIn(['appraisalNoticeForms', 'data'], fromJS(filtered));
    }

    case actions.FETCH_APPRAISAL_NOTICE_FORMS[START]:
      return state.setIn(
        ['appraisalNoticeForms', 'state'],
        fetchingState.FETCHING,
      );

    case actions.FETCH_APPRAISAL_NOTICE_FORMS[SUCCESS]:
      return state.setIn(
        ['appraisalNoticeForms', 'data'],
        fromJS(action.data.results),
      );

    case actions.FETCH_APPRAISAL_NOTICE_FORMS[ERROR]:
      return state.setIn(
        ['appraisalNoticeForms', 'state'],
        fetchingState.ERROR,
      );

    case actions.FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[START]:
      return state.setIn(
        ['appraisalNoticeFormOptions', 'state'],
        fetchingState.FETCHING,
      );

    case actions.FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[SUCCESS]:
      return state.setIn(
        ['appraisalNoticeFormOptions', 'data'],
        fromJS(action.data.results),
      );

    case actions.FETCH_APPRAISAL_NOTICE_FORM_OPTIONS[ERROR]:
      return state.setIn(
        ['appraisalNoticeFormOptions', 'state'],
        fetchingState.ERROR,
      );

    case actions.UPDATE_APPRAISAL_NOTICE_FORMS:
      return state.setIn(['appraisalNoticeForms', 'data'], fromJS(action.data));

    case actions.UPDATE_APPRAISAL_NOTICE_FORM: {
      const id = action.data.publicApprNoticeFormConfigID;
      const arr = state.getIn(['appraisalNoticeForms', 'data']).toJS();
      const newArr = arr.map((form) =>
        form.publicApprNoticeFormConfigID === id ? action.data : form,
      );
      return state.setIn(['appraisalNoticeForms', 'data'], fromJS(newArr));
    }
    default:
      return state;
  }
};
